import { render, staticRenderFns } from "./SearchableList.vue?vue&type=template&id=37b50471&scoped=true"
import script from "./SearchableList.vue?vue&type=script&lang=js"
export * from "./SearchableList.vue?vue&type=script&lang=js"
import style0 from "./SearchableList.vue?vue&type=style&index=0&id=37b50471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b50471",
  null
  
)

export default component.exports